import { Component, OnInit, inject } from '@angular/core';
import { NotificationService, StorageService, View } from '@lib/core';
import { Router } from '@angular/router';
import { DemandDataService } from '../demand-data.service';
import { Demand } from '../types/Demand';
import { CommentDataService } from '@lib/comment';
import { ItemClassificationDataService } from '@lib/classification';
import { FileDataService } from '@lib/file';
import { I18nService } from '@lib/i18n';

@Component({
    selector: 'create-demand',
    template: '',
    standalone: false,
})
export class CreateDemandComponent implements OnInit {
    private readonly notificationService = inject(NotificationService);
    private readonly router = inject(Router);
    private readonly storage = inject(StorageService);
    private readonly dataService = inject(DemandDataService);
    private readonly commentDataService = inject(CommentDataService);
    private readonly itemClassificationDataService = inject(ItemClassificationDataService);
    private readonly fileDataService = inject(FileDataService);
    private readonly i18n = inject(I18nService);


    async ngOnInit(): Promise<void> {
        this.notificationService.spinner.show();
        try {
            const demand: Demand = await Demand.current(
                this.dataService,
                this.commentDataService,
                this.itemClassificationDataService,
                this.fileDataService,
                this.i18n,
            );
            if (demand?.id) {
                this.router.navigate([View.CLIENT, 'rfq', 'demand', demand.id]);
            }
        } catch {
            this.router.navigate([View.CLIENT, 'home']);
        } finally {
            this.notificationService.spinner.hide();
        }
    }
}
